import { App } from '@capacitor/app';
import type { PluginListenerHandle } from '@capacitor/core';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Ouvre dans l'app native les liens reçus (universal links / schémas custom).
 * Monté à la racine du routeur pour fonctionner quel que soit l'écran affiché.
 */
export const useDeepLinking = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let listener: PluginListenerHandle | null = null;
    let cancelled = false;

    const setup = async () => {
      const handle = await App.addListener('appUrlOpen', (event) => {
        let url: URL;
        try {
          url = new URL(event.url);
        } catch {
          return;
        }
        // Schéma custom (vb20tn://set-password?...) : l'hôte porte le chemin.
        const isCustomScheme = !url.protocol.startsWith('http');
        const path = isCustomScheme ? `/${url.host}${url.pathname}`.replace(/\/+$/, '') : url.pathname;

        if (path.includes('/set-password')) {
          navigate(`/set-password${url.search}${url.hash}`, { replace: true });
          return;
        }
        if (path.includes('/login')) {
          navigate('/login', { replace: true });
        }
      });
      if (cancelled) handle.remove();
      else listener = handle;
    };

    setup();

    return () => {
      cancelled = true;
      listener?.remove();
    };
  }, [navigate]);
};
